import { render } from "./emailTemplate.vue?vue&type=template&id=1d95f57f&scoped=true"
import script from "./emailTemplate.vue?vue&type=script&lang=js"
export * from "./emailTemplate.vue?vue&type=script&lang=js"

import "./emailTemplate.vue?vue&type=style&index=0&id=1d95f57f&scoped=true&lang=css"

import exportComponent from "/var/www/html/conference/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d95f57f"]])

export default __exports__